import { c as _c } from "react/compiler-runtime";
import { UploadFileEntityResponse } from "@lib/generated/graphql";
import { useTranslation } from "next-i18next";
import Image, { ImageProps } from "next/image";
import { FC } from "react";
export interface StrapiImageProps extends Omit<Omit<ImageProps, "src">, "alt"> {
  image?: UploadFileEntityResponse | null;
  alt?: string;
}
const parseAltText = (locale: string, altText: string) => {
  try {
    const altData: {
      [key: string]: string;
    } = JSON.parse(altText);
    return altData[locale] ? altData[locale] : altText;
  } catch (e) {
    return altText;
  }
};
const StrapiImage: FC<StrapiImageProps> = t0 => {
  const $ = _c(15);
  let alt;
  let height;
  let image;
  let props;
  let width;
  if ($[0] !== t0) {
    ({
      image,
      width,
      height,
      alt,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = height;
    $[3] = image;
    $[4] = props;
    $[5] = width;
  } else {
    alt = $[1];
    height = $[2];
    image = $[3];
    props = $[4];
    width = $[5];
  }
  const {
    i18n
  } = useTranslation();
  if (!image?.data?.attributes?.url) {
    return null;
  }
  const intrinsicHeight = props.fill ? height : height || image.data.attributes.height as number;
  const intrinsicWidth = props.fill ? width : width || image.data.attributes.width as number;
  if (typeof alt === "undefined") {
    const t1 = image.data.attributes.alternativeText || "";
    let t2;
    if ($[6] !== i18n.language || $[7] !== t1) {
      t2 = parseAltText(i18n.language, t1);
      $[6] = i18n.language;
      $[7] = t1;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    alt = t2;
  }
  let t1;
  if ($[9] !== alt || $[10] !== image.data.attributes.url || $[11] !== intrinsicHeight || $[12] !== intrinsicWidth || $[13] !== props) {
    t1 = <Image {...props} alt={alt} src={image.data.attributes.url} height={intrinsicHeight} width={intrinsicWidth} />;
    $[9] = alt;
    $[10] = image.data.attributes.url;
    $[11] = intrinsicHeight;
    $[12] = intrinsicWidth;
    $[13] = props;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  return t1;
};
export default StrapiImage;